import React from 'react';
import Loadable from 'react-loadable'

import DefaultLayout from './containers/DefaultLayout';

function Loading() {
  return <div>Loading...</div>;
}

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const CreateView = Loadable({
  loader: () => import('./views/CreateView'),
  loading: Loading,
});

const BuildView = Loadable({
  loader: () => import('./views/BuildView'),
  loading: Loading,
});

const ManageScene = Loadable({
  loader: () => import('./views/ManageView/ManageScene'),
  loading: Loading,
});

const PushManager = Loadable({
  loader: () => import('./views/GrowView/PushManager'),
  loading: Loading,
});

const SubScription = Loadable({
  loader: () => import('./views/ManageView/SubScription'),
  loading: Loading,
});

const GrowView = Loadable({
  loader: () => import('./views/GrowView'),
  loading: Loading,
});

const SocialView = Loadable({
  loader: () => import('./views/GrowView/SocialView'),
  loading: Loading,
});

const AddonsView = Loadable({
  loader: () => import('./views/AddonsView'),
  loading: Loading,
});

const ArView = Loadable({
  loader: () => import('./views/AddonsView/ArView'),
  loading: Loading,
});

const VrView = Loadable({
  loader: () => import('./views/AddonsView/VrView'),
  loading: Loading,
});

const PublishView = Loadable({
  loader: () => import('./views/PublishView'),
  loading: Loading,
});

const SettingView = Loadable({
  loader: () => import('./views/SettingView'),
  loading: Loading,
});

const AnalyticsView = Loadable({
  loader: () => import('./views/AnalyticsView'),
  loading: Loading,
});

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', exact: true, name: 'Home', component: DefaultLayout },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/create', name: 'Create', component: CreateView },
  { path: '/build', name: 'Build', component: BuildView },
  { path: '/setting', name: 'Setting', component: SettingView },
  { path: '/analytics', name: 'Analytics', component: AnalyticsView },

  { path: '/manage', exact: true, name: 'Manage', component: ManageScene },
  { path: '/manage/manage-scene', name: 'My scenes', component: ManageScene },
  { path: '/manage/sub-scription', name: 'My subscription', component: SubScription },

  { path: '/grow', exact: true, name: 'Grow', component: GrowView },
  { path: '/grow/push-manager', name: 'Push notification', component: PushManager },
  { path: '/grow/social', name: 'Social', component: SocialView },

  { path: '/addons/ar', name: 'AR', component: ArView },
  { path: '/addons/vr', name: 'VR', component: VrView },
  { path: '/addons', name: 'Grow', component: AddonsView },
  { path: '/preview', name: 'Grow', component: PublishView },

  { path: '/analytics', name: 'Analytics', component: AnalyticsView },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js